import SessionEventProto from "../session-event-proto"
import {EVENT_BUS_SESSION_RESOURCES_CHANGED} from "./@const"


export default class SessionEvent_ResourceDelete extends SessionEventProto {

    private resource: { id: ID }

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.resource = sessionEvent.resource
    }

    process() {
        const id = this.resource?.id
        if (!id) return

        const resource = gd.session.resources.get(id)
        if (!resource) return

        resource.isDeleted = true
        gd.bus.triggerEvent(EVENT_BUS_SESSION_RESOURCES_CHANGED)
    }
}
